import { render, staticRenderFns } from "./ReyrockLanding.vue?vue&type=template&id=5bc8d058"
import script from "./ReyrockLanding.vue?vue&type=script&lang=js"
export * from "./ReyrockLanding.vue?vue&type=script&lang=js"
import style0 from "./ReyrockLanding.vue?vue&type=style&index=0&id=5bc8d058&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports